import script from "./WhatAwaitsList.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatAwaitsList.vue?vue&type=script&setup=true&lang=js"

import "./WhatAwaitsList.vue?vue&type=style&index=0&id=fd4c77e2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd4c77e2"]])

export default __exports__